import React from "react";

import { CheckBox } from "widgets";
import AddressFields from "./AddressFields";

import styles from "./AddressForm.module.scss";

const AddressForm = (props) => {
  const {
    billingAddress,
    shippingAddress,
    handleChangeBillingAddress,
    handleChangeShippingAddress,
    useSameAddress,
    hasHardware,
    handleUseSameAddress,
    handleBlur,
    errors,
    validateForm,
    selectedVerticalId,
    countryName,
    isdCode,
    countryCode,
    onIsdCodeChange,
    gatewayTenantId,
  } = props;

  return (
    <div className={styles.addressContainer}>
      <section className={styles.addressBox}>
        <header className={styles.sectionHeader}>
          <div className={styles.sectionHeadings}>
            <div className={styles.addressTitle}>Billing Details</div>
            <div className={styles.text}>
              This address is used for invoice generation.
            </div>
          </div>
        </header>
        <AddressFields
          address={billingAddress || {}}
          handleChangeFields={handleChangeBillingAddress}
          errors={errors.orderDetails}
          handleBlur={handleBlur}
          addressType="billing"
          validateForm={validateForm}
          selectedVerticalId={selectedVerticalId}
          countryName={countryName}
          isdCode={isdCode}
          countryCode={countryCode}
          onIsdCodeChange={onIsdCodeChange}
          gatewayTenantId={gatewayTenantId}
        />
      </section>
      {hasHardware && (
        <section className={styles.addressBox}>
          <header className={styles.sectionHeader}>
            <div className={styles.sectionHeadings}>
              <div className={styles.addressTitle}>Shipping Details</div>
              <div className={styles.text}>
                Where the hardware and printed material will be delivered.
              </div>
            </div>
            <div className={styles.sameAddressToggle}>
              <CheckBox
                title="Same as billing address"
                checked={useSameAddress}
                handleCheck={handleUseSameAddress}
              />
            </div>
          </header>
          <AddressFields
            address={
              useSameAddress ? billingAddress || {} : shippingAddress || {}
            }
            handleChangeFields={handleChangeShippingAddress}
            errors={errors.orderDetails}
            disabled={useSameAddress}
            handleBlur={handleBlur}
            addressType="shipping"
            validateForm={validateForm}
            selectedVerticalId={selectedVerticalId}
            countryName={countryName}
            isdCode={isdCode}
            countryCode={countryCode}
            onIsdCodeChange={onIsdCodeChange}
            gatewayTenantId={gatewayTenantId}
          />
        </section>
      )}
    </div>
  );
};

export default AddressForm;
